import DateAndPlsce from './date-and-place';

export default DateAndPlsce;
